import React, { memo } from "react";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Switch, Typography } from "antd";
import * as S from "../styled/index.styled";

const { Title } = Typography;

interface IPropsSwitchComponent {
  title: string;
  name: string;
  checked: boolean;
  onChange: (...args) => void;
  dataTestId: string;
  disabled?: boolean;
}

export const SwitchComponent = memo(({ title, name, checked, onChange, dataTestId, disabled }: IPropsSwitchComponent): JSX.Element => {
  return (
    <>
      <S.ConfigurationsGroup>
        <Title level={5} style={S.ConfigurationDescription}>
          {title}
        </Title>
      </S.ConfigurationsGroup>
      <S.FormItemFieldName label="" name={name}>
        <Switch
          className="switch-component"
          data-testid={dataTestId}
          checked={checked}
          checkedChildren={<CheckOutlined />}
          unCheckedChildren={<CloseOutlined />}
          onChange={onChange}
          disabled={disabled}
        />
      </S.FormItemFieldName>
    </>
  );
});
